import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const FooterContainer = styled.footer`
  position: static;
  width: 100%;
  padding: 2rem 2rem 4rem 2rem;
  margin-bottom: -2rem; /* Adjust to match ticker height */
  background-color: #13182a;
  border-top: 2px solid #f0f0f0;

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`;

const Copyright = styled.div`
  font-size: 1rem;
  color: #f0f0f0;
  font-family: 'Garamond', serif;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const FooterLink = styled.div`
  text-decoration: none;
  color: #f0f0f0;
  font-family: 'Garamond', serif;
  font-size: 1rem;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #ffffff;
    // add bold effect on hover
    // font-weight: bold;
  }
`;

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <Copyright>© {currentYear} Heaviside. All rights reserved.</Copyright>
        <FooterLinks>
          <FooterLink onClick={() => navigate('/terms')}>Terms</FooterLink>
          <FooterLink onClick={() => navigate('/privacy')}>Privacy</FooterLink>
          {/* <FooterLink onClick={() => navigate('/disclaimer')}>
            Disclaimer
          </FooterLink> */}
        </FooterLinks>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
